import { CookieHelper } from "@/helper/cookieHelper"
import { ColorConstruct } from "@/utilityModels/colorConstruct"

const COOKIE_COLOR_SKIN = 'colorSkin';

export class UserConfigColors
{
    // バラしたい
    public static defaultColorSkin = {
        controlColor: {
            r : 41,
            g : 179,
            b : 91,
        },
        backgroundColor: {
            r : 255,
            g : 255,
            b : 255,
        },
        textAColor: {
            r : 6,
            g : 49,
            b : 22,
        },
        textBColor: {
            r : 1,
            g : 98,
            b : 36,
        },
    };

    private _colors = UserConfigColors.defaultColorSkin;

    get colors()
    {
        return this._colors;
    }

    set colors(colors)
    {
        this._colors = colors;
    }

    constructor()
    {
        if (CookieHelper.hasItem(COOKIE_COLOR_SKIN)) {
            this.colors = CookieHelper.getItem(COOKIE_COLOR_SKIN);
        }
    }

    update()
    {
        this.colors = CookieHelper.getItem(COOKIE_COLOR_SKIN);
    }

    // ボタンの色
    get buttonColorCode(){ return new ColorConstruct(this.colors.controlColor.r , this.colors.controlColor.g , this.colors.controlColor.b).hex }
    // ボタンの色のRGB
    private get buttonColorRgb(){
        return {
            r : parseInt(this.buttonColorCode.substring(1, 3), 16),
            g : parseInt(this.buttonColorCode.substring(3, 5), 16),
            b : parseInt(this.buttonColorCode.substring(5, 7), 16)
        }
    }
    // ボタンの色のRGBA指定
    private get buttonColorRgba(){
        return "rgba(" + parseInt(this.buttonColorCode.substring(1, 3), 16)
                + " , " + parseInt(this.buttonColorCode.substring(3, 5), 16)
                + " , " + parseInt(this.buttonColorCode.substring(5, 7), 16)
                + " , 0.3)";
    }
    // 濃いボタンの色（ズームの吹き出しに使用）
    get darkButtonColorCode(){ 

        var colorCode = this.buttonColorCode.slice( 1 ) ;

        return this.darken(colorCode , 0.5);
    }

    // 背景色
    get backgroundColor(){ return new ColorConstruct(this.colors.backgroundColor.r , this.colors.backgroundColor.g , this.colors.backgroundColor.b).hex }
    
    // 文字色A
    get textAColor(){ return new ColorConstruct(this.colors.textAColor.r , this.colors.textAColor.g , this.colors.textAColor.b).hex }

    // 文字色B
    get textBColor(){ return new ColorConstruct(this.colors.textBColor.r , this.colors.textBColor.g , this.colors.textBColor.b).hex }

    private get userConfigColors(){
        return {
            buttonColorCode : this.buttonColorCode,
            darkButtonColorCode : this.darkButtonColorCode,
            backgroundColor : this.backgroundColor,
            textAColor : this.textAColor,
            textBColor : this.textBColor
        };
    }
    
    

    darken(hexstr, scalefactor) {
        var r = scalefactor;
        var a, i;
        if (typeof(hexstr) != 'string') {
          return hexstr;
        }
        hexstr = hexstr.replace(/[^0-9a-f]+/ig, '');
        if (hexstr.length == 3) {
          a = hexstr.split('');
        } else if (hexstr.length == 6) {
          a = hexstr.match(/(\w{2})/g);
        } else {
          return hexstr;
        }
        for (i=0; i<a.length; i++) {
          if (a[i].length == 2)
            a[i] = parseInt(a[i], 16);
          else {
            a[i] = parseInt(a[i], 16);
            a[i] = a[i]*16 + a[i];
          }
        }
      
        var maxColor = parseInt('ff', 16);
      
        function _darken(a) {
          return a * r;
        }
      
        for (i=0; i<a.length; i++) {
          a[i] = _darken(a[i]);
          a[i] = Math.floor(a[i]).toString(16);
          if (a[i].length == 1) {
            a[i] = '0' + a[i];
          }
        }
        return "#" + a.join('');
      }
    
}